import {
  Box,
  Grid,
  Paper,
} from "@material-ui/core";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { Form, Formik } from "formik";
import { ForgotPasswordModel } from "model/utilModels/ForgotPasswordModel";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ForgotPasswordSchema } from "schemas/menu/auth/ForgotPasswordSchema";
import { ForgotPasswordService } from "services/auth/ForgotPasswordService";
import SlidingpanelForLoginAndForgotPassword from "../slidingPanelForLoginAndForgotPassword/SlidingpanelForLoginAndForgotPassword";
import WebsiteMenu from "../websiteMenu/WebsiteMenu";
import "./ForgetPassword.scss";

const ForgetPassword = () => {

  const [initialValues, setInitialValues] = useState(new ForgotPasswordModel())

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={ForgotPasswordSchema}
        onSubmit={async(values:ForgotPasswordModel ,{resetForm}) => {
          const requestData = new ForgotPasswordModel();
          requestData.userName = values.userName;
          const res = await ForgotPasswordService.forgotPassword(requestData);
          if(res.statusMsg === msgTypes.SUCCESS.msg){
                resetForm();
          }
        }}
      >
        {({ isValid, dirty, isSubmitting, values }) => (
          <Form>
            {/* To display website menu on top of login and Forgot password page */}
            <WebsiteMenu />

            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                  <Box className=" main-box flex max-w-3 main-box-sec">
                    <Grid className="login-grid">
                      <Paper elevation={3} className="login-paper">
                        <div className="login-box p-4 ">
                          <div className="admin-logo-1">
                            <img
                              src="/images/1wn-logo.png"
                              alt="logo"
                            />
                          </div>
                          <h2>Reset Password</h2>
                          <p >Our Portal Admin will share a new password with you within 24hrs.</p>
                          <div className="form">
                            <div className="pb-4">
                            <FormikControl
                              control="textfield"
                              name="userName"
                              label="User Name"
                              placeholder="Enter User Name"
                              requiredField
                            />
                            </div>

                            <div>
                              <Box >
                                <FormikControl
                                  control="button"
                                  color="primary"
                                  className='btn btn-submit w-100'
                                  label="Send"
                                  type="submit"
                                  disabled={!dirty || !isValid}
                                />
                              </Box>
                              <p><Link to="/" className="btn btn-cancel m-0 mt-2 w-100" >Back</Link></p>
                            </div>
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  </Box>
                </div>

                {/* To display sliding panel  */}
                <SlidingpanelForLoginAndForgotPassword />

              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>

  );
};

export default ForgetPassword;
